const PROFILE_SECTIONS_KEYS = {
    sen: 'SEN',
    medicalConditions: 'MedicalConditions',
    parentalConsents: 'ParentalConsents'
};

const DEFAULT_PROFILE_SECTIONS_DESCRIPTIONS = {
    [PROFILE_SECTIONS_KEYS.medicalConditions]: 'Please tick @StudentName’s medical condition(s). If @StudentName has a medical condition does not appear in the list please select Other/Any Other Medical Condition. You should use the \'upload\' button to provide supplementary documentation - for example a diagnosis letter or a management plan related to the condition. The Summary field that appears beneath the uploaded document should be used to describe the type of document being uploaded. The Notes field below the Summary can be used to provide additional details and information you would like @SchoolName to know about @StudentName’s medical condition, for example, the type and dose of medication required and whether it is taken during the school day.',
    [PROFILE_SECTIONS_KEYS.sen]: 'PLEASE TICK THE MOST APPROPRIATE OPTION FROM THE LIST OF SEN CONDITIONS BELOW AND PROVIDE A SHORT SUMMARY. USE THE ‘ADD DOCUMENT’ BUTTON TO PROVIDE US WITH ANY RELEVANT DOCUMENTATION OR ADDITIONAL INFORMATION.',
    [PROFILE_SECTIONS_KEYS.parentalConsents]: '',
};

const PLACEHOLDERS = [
    {id: 'schoolName', display: 'School Name', value: '@SchoolName'},
    {id: 'studentName', display: 'Student Name', value: '@StudentName'}
];

export {
    PROFILE_SECTIONS_KEYS,
    DEFAULT_PROFILE_SECTIONS_DESCRIPTIONS,
    PLACEHOLDERS
}